<div class="wrapper theme2">

    <div class="block-content">
        
            <app-public-menu></app-public-menu>
            <div class="fadein animation-duration-500 grid container">
                <div class="text-center relative col-12 slide-text-wrapper">
                    <div class="text-6xl font-bold mb-1 text-gradient">Preguntas Frecuentes
                    </div>
                    <div class="text-yellow font-bold mb-4 ">¿Tienes alguna duda? Aquí responderemos a las preguntas mas
                        frecuentes</div>

                </div>
            </div>
            <div class="padding">
                <div class="flex mb-3 gap-2 justify-content-end">
                    <p-button (click)="activeIndex = 0" rounded="true" label="1"
                        styleClass="w-2rem h-2rem p-0"></p-button>
                    <p-button (click)="activeIndex = 1" rounded="true" label="2"
                        styleClass="w-2rem h-2rem p-0"></p-button>
                    <p-button (click)="activeIndex = 2" rounded="true" label="3"
                        styleClass="w-2rem h-2rem p-0"></p-button>
                    <p-button (click)="activeIndex = 3" rounded="true" label="3"
                        styleClass="w-2rem h-2rem p-0"></p-button>
                    <p-button (click)="activeIndex = 4" rounded="true" label="4"
                        styleClass="w-2rem h-2rem p-0"></p-button>
                    <p-button (click)="activeIndex = 5" rounded="true" label="5"
                        styleClass="w-2rem h-2rem p-0"></p-button>
                    <p-button (click)="activeIndex = 6" rounded="true" label="6"
                        styleClass="w-2rem h-2rem p-0"></p-button>
                    <p-button (click)="activeIndex = 7" rounded="true" label="7"
                        styleClass="w-2rem h-2rem p-0"></p-button>
                    <p-button (click)="activeIndex = 8" rounded="true" label="8"
                        styleClass="w-2rem h-2rem p-0"></p-button>
                    <p-button (click)="activeIndex = 9" rounded="true" label="9"
                        styleClass="w-2rem h-2rem p-0"></p-button>
                    <p-button (click)="activeIndex = 10" rounded="true" label="10"
                        styleClass="w-2rem h-2rem p-0"></p-button>

                </div>
                <p-accordion (activeIndexChange)="activeIndexChange($event)" [activeIndex]="activeIndex">
                    <p-accordionTab
                        header="1. ¿Qué sucede si cambian las regulaciones del mercado inmobiliario y afectan a mi inversión? ">
                        <p class="m-0">
                            En el caso de que haya cambios regulatorios, Easyrentestate actúa proactivamente para
                            adaptar las estrategias de inversión, siempre buscando proteger los intereses de nuestros
                            inversores. Mantenemos una vigilancia constante sobre el entorno legal para anticiparnos a
                            posibles impactos y ajustar nuestras operaciones de manera que minimicemos riesgos y
                            maximicemos las oportunidades.
                        </p>
                    </p-accordionTab>
                    <p-accordionTab
                        header="2. ¿Qué ocurre si una propiedad seleccionada por Easyrentestate no logra el retorno esperado? ">
                        <p class="m-0">
                            Entendemos que no todas las inversiones pueden cumplir con las expectativas inicialmente
                            proyectadas. En tales casos, implementamos planes de acción que pueden incluir desde la
                            reevaluación y ajuste de la estrategia de la propiedad hasta su posible venta o
                            reestructuración del proyecto. Nuestro compromiso es mantener informados a nuestros
                            inversores y tomar decisiones basadas en la optimización del valor y la recuperación de la
                            inversión.
                        </p>
                    </p-accordionTab>
                    <p-accordionTab header="3. ¿Cómo maneja Easyrentestate los retrasos en los desarrollos o proyectos? ">
                        <p class="m-0">
                            Los retrasos en los proyectos pueden ocurrir por diversas razones. Ante esta eventualidad,
                            nuestro equipo se comunica de manera transparente con los inversores, proporcionando
                            actualizaciones regulares y explicando las razones detrás de los retrasos. Buscamos
                            soluciones efectivas, como la reasignación de recursos o la modificación de los plazos, para
                            mitigar el impacto y asegurar la continuación exitosa del proyecto.
                        </p>
                    </p-accordionTab>
                    <p-accordionTab
                        header="4. En el caso de una baja de una inversión en el mercado, ¿cómo protege Easyrentestate las inversiones de sus clientes?">
                        <p class="m-0">
                            La volatilidad del mercado es una realidad con la que todas las inversiones deben lidiar. En
                            Easyrentestate, diversificamos el portafolio de propiedades y aplicamos un análisis de
                            riesgo detallado para cada inversión, lo cual nos permite mitigar los efectos de una posible
                            baja del mercado. Además, nuestro enfoque en propiedades con potencial de valorización a
                            largo plazo y la constante reevaluación de nuestras estrategias de inversión son clave para
                            proteger los intereses de nuestros inversores durante los períodos de incertidumbre del
                            mercado.
                            5
                        </p>
                    </p-accordionTab>
                    <p-accordionTab
                        header="5. ¿Cómo responde Easyrentestate a las críticas sobre su modelo de negocio o estrategias de inversión? ">
                        <p class="m-0">
                            Aceptamos las críticas como una oportunidad para mejorar y crecer. Cuando surgen
                            preocupaciones sobre nuestro modelo de negocio o estrategias, las evaluamos cuidadosamente y
                            buscamos feedback directo de nuestros inversores y stakeholders. Estamos comprometidos con
                            la mejora continua y la adaptación de nuestras operaciones y estrategias para satisfacer las
                            necesidades y expectativas de nuestros inversores, siempre manteniendo nuestros principios
                            de transparencia, integridad y responsabilidad social.

                        </p>
                    </p-accordionTab>
                    <p-accordionTab
                        header="6. ¿Cómo garantiza Easyrentestate la seguridad de mi inversión en tiempos de incertidumbre económica? ">
                        <p class="m-0">
                            En períodos de incertidumbre económica, reforzamos nuestra estrategia de diversificación y
                            analizamos meticulosamente el mercado para identificar oportunidades de inversión
                            resilientes. Además, ajustamos nuestras operaciones para fortalecer la posición financiera
                            de nuestras inversiones, buscando siempre proteger y maximizar el capital de nuestros
                            inversores.
                        </p>
                    </p-accordionTab>
                    <p-accordionTab header="7. ¿Existen costos ocultos en las inversiones con Easyrentestate? ">
                        <p class="m-0">
                            No hay tarifas ocultas; cualquier gasto o comisión se detalla en la documentación
                            proporcionada antes de realizar cualquier inversión.

                        </p>
                    </p-accordionTab>
                    <p-accordionTab
                        header="8. ¿Cómo se seleccionan los proyectos de inversión en Easyrentestate y cuál es el criterio para su evaluación? ">
                        <p class="m-0">
                            La selección de proyectos se basa en un riguroso proceso que incluye análisis de mercado,
                            evaluaciones de riesgo, potencial de valorización y sostenibilidad. Este proceso nos permite
                            identificar proyectos con las mayores oportunidades de éxito y alineados con nuestros
                            valores de responsabilidad social y económica.

                        </p>
                    </p-accordionTab>
                    <p-accordionTab
                        header="9. ¿Qué medidas toma Easyrentestate para asegurar la satisfacción del inversor a largo plazo? ">
                        <p class="m-0">
                            Para asegurar la satisfacción a largo plazo, mantenemos una comunicación constante y
                            transparente, ofreciendo informes periódicos sobre el desempeño de las inversiones y el
                            estado de los proyectos. Además, adaptamos nuestras estrategias basándonos en el feedback de
                            los inversores y las tendencias del mercado, asegurando que nuestras inversiones sigan
                            siendo competitivas y rentables.
                        </p>
                    </p-accordionTab>
                    <p-accordionTab
                        header="10. ¿Cómo puedo monitorear el progreso y desempeño de mi inversión con Easyrentestate? ">
                        <p class="m-0">
                            Ofrecemos una plataforma en línea accesible donde puedes monitorear el progreso y desempeño
                            de tu inversión ¿¿en tiempo real??. Esta plataforma proporciona actualizaciones detalladas
                            permitiéndote tener un control y visibilidad completos sobre tu inversión.

                        </p>
                    </p-accordionTab>
                    <p-accordionTab header="11. ¿Ofrece Easyrentestate asesoramiento personalizado para inversores? ">
                        <p class="m-0">
                            Sí, ofrecemos asesoramiento personalizado a todos nuestros inversores. Entendemos que cada
                            inversor tiene objetivos y circunstancias únicas, por lo que nuestro equipo está disponible
                            para proporcionar orientación personalizada, ayudándote a tomar decisiones de inversión
                            informadas y alineadas con tus metas financieras personales.

                        </p>
                    </p-accordionTab>
                </p-accordion>
            </div>
       

        <!----><!---->
    </div>
</div>

<app-public-footer></app-public-footer>